var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"services-infoBanner"},[_c('div',{staticClass:"services-infoBanner-container"},[_c('div',{staticClass:"services-infoBanner-content"},[_c('h3',{staticClass:"services-infoBanner-title"},[_vm._v(_vm._s(_vm.$locale["services-info-banner"]))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }